import * as styles from './GretaAIChatMarkdownTable.module.css'

function GretaAIChatMarkdownTable({ children }) {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>{children}</table>
    </div>
  )
}

export default GretaAIChatMarkdownTable
